export default __webpack_public_path__ + "static/media/onda.120d8460.svg";